import { memo, useState } from 'react';

import { TextareaAutosize } from '@mui/material';

import { OProgressBar } from '@src/shared';

import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

import { TInputOptionType } from '@src/types';

import './optionDropdown.scss';

interface IProps {
  label: string;
  percentage?: number;
  type?: TInputOptionType;
  optionIcon?: React.ReactNode;
  dropdownLabel: string;
  dropdownText: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  isDropdownHidden?: boolean;
  onOptionClick?: () => void;
}

const OptionDropdown = ({
  label,
  type = 'SINGLE',
  dropdownLabel,
  dropdownText,
  optionIcon,
  percentage,
  isChecked = false,
  isDisabled = false,
  isDropdownHidden = false,
  onOptionClick = () => {},
}: IProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="option-dropdown-container">
      <div className="option-info">
        {type === 'SINGLE' && (
          <div className="radio-container">
            <label className={`radio-label ${isDisabled ? 'disabled' : ''}`}>
              {!isDisabled && <input type="radio" checked={isChecked} onChange={onOptionClick} />}
              {label}
            </label>
          </div>
        )}
        {type === 'MULTIPLE' && (
          <div className="radio-container">
            <label className={`radio-label ${isDisabled ? 'disabled' : ''}`}>
              {!isDisabled && <input type="checkbox" checked={isChecked} onChange={onOptionClick} />}
              {label}
            </label>
          </div>
        )}
        <div
          className={`dropdown-container ${!dropdownText.length ? 'disabled' : ''}`}
          onClick={() => !isDropdownHidden && setIsDropdownOpen((prev) => !prev)}
        >
          <div className="dropdown-button">
            {optionIcon && optionIcon}
            {dropdownLabel}
            {typeof percentage !== 'undefined' && <span>%{percentage}</span>}
          </div>
          {!isDropdownHidden && (
            <div className="dropdown-icon">
              {isDropdownOpen ? <IoIosArrowUp size={18} /> : <IoIosArrowDown size={18} />}
            </div>
          )}
        </div>
      </div>
      {isDropdownOpen && !isDropdownHidden && (
        <div className="voters-container">
          <TextareaAutosize disabled className="voters-textarea" value={dropdownText} />
        </div>
      )}
      <OProgressBar isDisabled={isDisabled} percentage={percentage || 0} />
    </div>
  );
};

export default memo(OptionDropdown);
